/**
 * `TRPCError.cause.code` when an application is submitted while a required
 * screening form is unsubmitted. The apply dialog refetches the forms on it.
 */
export const APPLICATION_FORMS_REQUIRED_ERROR_CODE =
  "APPLICATION_FORMS_REQUIRED";
